import React from "react";
import { useTranslation } from "react-i18next";
import BaseModal from "../../components/BaseModal";
import { MODAL_TYPES } from "../../utils/emitter";
import "./style.scss";

// РЕКОМЕНДАЦИЯ индивидуальной (пустой) анкеты (Figma 11921-48981 / 11925-49089):
// неоновый титл с бабочкой сверху, нумерованные секции с фиолетовыми
// заголовками, блок «Важно» в рамке, финальный блок без номера.
// Открывается кнопкой «Рекомендации» на странице парного просмотра BLANK-анкеты;
// payload { invited: true } — версия для ещё не заполнившего свою половину.
export default function BlankRecommendationModal() {
  const [payload, setPayload] = React.useState(null);
  const { t } = useTranslation();
  const blocks = t(
    payload?.invited
      ? "blank_form.recommendation_invited.blocks"
      : "blank_form.recommendation.blocks",
    {
      returnObjects: true,
    }
  );
  const list = Array.isArray(blocks) ? blocks : [];
  const importantTitles = ["Важно", "Important"];
  const finalTitles = ["В конце", "In the end"];
  let sectionNumber = 0;

  return (
    <BaseModal
      className="blank-recommendation-modal"
      eventTypeModal={MODAL_TYPES.BLANK_RECOMMENDATION}
      onPayload={(data) => setPayload(data || null)}
      isNeonTitle
      title={t("blank_form.recommendation.title")}
      description={
        <span className="blank-recommendation-modal__content">
          {list.map((block, i) => {
            const isImportant = importantTitles.includes(block.title);
            const isFinal = finalTitles.includes(block.title);
            if (isImportant) {
              return (
                <span
                  key={i}
                  className="blank-recommendation-modal__important"
                >
                  <span
                    className="blank-recommendation-modal__important-title neon-text"
                    data-text={block.title}
                  >
                    {block.title}
                  </span>
                  <span className="blank-recommendation-modal__text">
                    {block.text}
                  </span>
                </span>
              );
            }
            if (isFinal) {
              return (
                <span key={i} className="blank-recommendation-modal__final">
                  {block.text}
                </span>
              );
            }
            sectionNumber += 1;
            return (
              <span key={i} className="blank-recommendation-modal__section">
                <span className="blank-recommendation-modal__section-head">
                  <span className="blank-recommendation-modal__num">
                    {sectionNumber}
                  </span>
                  <span className="blank-recommendation-modal__section-title">
                    {block.title}
                  </span>
                </span>
                <span className="blank-recommendation-modal__text">
                  {block.text}
                </span>
              </span>
            );
          })}
        </span>
      }
    />
  );
}
